// スムーススクロール
$(function () {
  var headerH = $('header#header').outerHeight() || 0;
  var speed = 500;

  function scrollToPosition(position) {
    $('html, body').animate({ scrollTop: Math.max(0, position) }, speed, 'swing');
  }

  function updateHash(hash) {
    var url = window.location.pathname + window.location.search + (hash || '');
    if (history.pushState) {
      history.pushState(null, '', url);
    } else if (hash) {
      window.location.hash = hash;
    } else {
      window.location.hash = '';
    }
  }

  $('.js-page-top').on('click', function (e) {
    e.preventDefault();
    scrollToPosition(0);
    updateHash('');
    return false;
  });

  $('a[href^="#"]')
    .not('.js-page-top')
    .not('.skip-to-content-link')
    .not('[aria-haspopup="dialog"]')
    .on('click', function (e) {
      var href = $(this).attr('href');
      if (!href || href === '#') return;

      var $target = $(href);
      if (!$target.length) return;

      e.preventDefault();
      scrollToPosition($target.offset().top - headerH);
      updateHash(href);
      return false;
    });

  var hash = location.hash;
  if (hash) {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);

    var $target = $(hash);
    if ($target.length) {
      scrollToPosition($target.offset().top - headerH);
    }
  }
});
